import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Play } from "lucide-react";
import { Button } from "./ui/button";
import { contact } from "../mock";

export default function WelcomeSection() {
  const [playing, setPlaying] = React.useState(false);
  return (
    <section className="bg-cream bg-dotted py-16 md:py-24 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">An ISO 9001:2015 Certified Company</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">ESS BEE HEATERS <span className="text-orange-500">PVT. LTD.</span></h2>
          <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
          <p className="mt-5 max-w-3xl mx-auto text-neutral-600">
            Leading Manufacturer Of Industrial Heaters &amp; Heating Elements — Shortwave IR Heaters and Shortwave IR Heaters with Reflector Box. Trusted by 1000+ clients across India since 2000.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mt-16">
          <div>
            <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">Welcome To</p>
            <h3 className="font-display text-3xl md:text-4xl font-bold mt-3 uppercase">Ess Bee Heaters Pvt. Ltd.</h3>
            <span className="block w-20 h-[3px] bg-orange-500 mt-4" />
            <p className="mt-6 text-neutral-700 leading-relaxed">
              We are a trusted and pioneering manufacturer of Commercial &amp; Industrial Heaters &amp; Heating Elements, delivering high-performance heating solutions powered by advanced technology and decades of technical expertise.
            </p>
            <p className="mt-4 text-neutral-700 leading-relaxed">
              Our focus on innovation, efficiency, and reliability has made us a preferred partner for customers seeking consistent performance and long service life for their equipment and machinery.
            </p>
            <div className="grid grid-cols-2 gap-3 mt-6 max-w-md">
              {["ISO 9001:2015 Certified", "RoHS Compliant", "CE Certified", "Quality Tested"].map(t => (
                <div key={t} className="flex items-center gap-2 text-sm text-neutral-800">
                  <CheckCircle2 size={18} className="text-orange-500 shrink-0" />
                  <span>{t}</span>
                </div>
              ))}
            </div>
            <Link to="/about" className="inline-block mt-7">
              <Button className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-7 py-6 font-semibold uppercase tracking-wider">Read More →</Button>
            </Link>
          </div>

          <div className="relative">
            <div className="relative rounded-xl overflow-hidden shadow-xl ring-1 ring-black/5 bg-black aspect-video">
              {playing ? (
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${contact.youtubeId}?autoplay=1&rel=0`}
                  title="ESS BEE HEATERS PVT. LTD."
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              ) : (
                <button onClick={() => setPlaying(true)} className="group w-full h-full relative" aria-label="Play video">
                  <img src={`https://img.youtube.com/vi/${contact.youtubeId}/maxresdefault.jpg`} alt="video thumbnail" className="w-full h-full object-cover" />
                  <span className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition-colors">
                    <span className="w-20 h-20 rounded-full bg-orange-500 text-white flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                      <Play size={32} className="ml-1" fill="white" />
                    </span>
                  </span>
                </button>
              )}
            </div>
            <div className="absolute -bottom-6 -right-2 md:right-8 bg-orange-500 text-white px-6 py-4 rounded-lg shadow-xl">
              <p className="font-display text-3xl font-bold leading-none">25+</p>
              <p className="text-xs uppercase tracking-wider mt-1">Years of Excellence</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
